import React from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { sortOpts } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

class EditPostForm extends Form {

  componentWillMount(){
    this.setState({data:this.props.data,delConf:false});
  }

  savePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    const newD = this.state.data;
    if (!isEqual(oldD, newD)) {
      this.props.editPost(newD, () => {
        this.props.cancelEdit();
        const diff = oldD.post_price*oldD.post_qntt*oldD.post_payed
          - newD.post_price*newD.post_qntt*newD.post_payed;
        if(this.props.blnc === 1 ){
          this.props.updtBlnc(newD.post_order_id,0,diff,0);
        }
        else{
          this.props.updtBlnc(newD.post_order_id,0,0,diff);
        }
      });
    }
    else {
      this.props.cancelEdit();
    }
  }

  deletePost = e => {
    e.preventDefault();
    const oldD = this.props.data;
    this.props.editPost({
      ...oldD,
      post_active:0
    }, () => {
      this.props.cancelEdit();
      const diff = oldD.post_price*oldD.post_qntt;
      if(this.props.blnc === 1 ){
        this.props.updtBlnc(oldD.post_order_id,0,diff,0);
      }
      else{
        this.props.updtBlnc(oldD.post_order_id,0,0,diff);
      }
    });
  }

  updateSrvc = e => {
    this.setState({
      data:{
        ...this.state.data,
        post_srvc_id:e.value,
        post_desc:this.props.srvcs[e.value].srvc_desc
      }
    });
  }

  payedToday = () => {
    this.setState({
      data:{
        ...this.state.data,
        post_bdate: moment().format('Y-MM-DD'),
        post_payed: 1
      }
    });
  }

  render() {
    const { srvcs } = this.props;

    const post = this.state.data;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deletePost}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key) && ((srvcs[key].srvc_active === 1
        && srvcs[key].srvc_type === -1)
        || srvcs[key].srvc_id === post.post_srvc_id)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          {delConf}
          <div className="form-group">
            <Select
              clearable={false}
              options={srvcsOpt}
              value={post.post_srvc_id}
              onChange={this.updateSrvc}
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.savePost} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.props.cancelEdit} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>{" "}
            <button type="button" className="btn btn-danger"
              onClick={this.toggleDelConf} title="Удалить">
              <span className="glyphicon glyphicon-trash"></span>
            </button>
          </div>
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control"
            value={post.post_price}
            name="post_price"
            onChange={this.updateInput}
          />
        </td>
        <td className="form-group">
          <label style={{cursor:'pointer',fontWeight:(post.post_payed?'bold':'normal')}}>
            Оплачено{" "}
            <input type="checkbox" checked={post.post_payed}
              name="post_payed" onChange={this.handleChBox} />
          </label>{" "}
          <span style={{cursor:'pointer',textDecoration:'underline'}}
            onClick={this.payedToday}>Сегодня</span>
          <br />
          <DatePicker
            className="form-control"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            selected={moment(post.post_bdate)}
            onChange={(e) => this.updateDate(e, 'post_bdate')}
          />
        </td>
        <td className="form-group">
          <textarea type="text"
            className="form-control"
            value={post.post_note}
            cols="80"
            placeholder="Заметка"
            title="Заметка"
            name="post_note"
            onChange={this.updateInput}
          />
        </td>
      </tr>
    );
  }
}

export default EditPostForm;



// WEBPACK FOOTER //
// ./src/components/payment/EditPaymentForm.js